/**
 * Initialize catalog
 */
$(function() {
    $.ajax({
        url: `${getLocalePrefix()}/travel/offer/prices`,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            $('.loader-item').remove()
            const offerPrices = data.offerPrices
            if(Object.keys(offerPrices).length > 0) {
                for (const offerId in offerPrices) {
                    const offerItem = $(`a[data-offer=${offerId}]`)
                    $(offerItem).find('.loader-item').remove()
                    $(offerItem).find('.travel--item-cost').append(`
                        ${renderPrice(offerPrices[offerId])}
                    `)
                }
            }
        },
        //error: function (data) {
        //    console.log(data)
        //}
    })
});
